













import Vue from 'vue'
import { AmataModal } from '@/components/AmataModal'
import { removeElement } from '@/utils/helpers'

export default Vue.extend({
  name: 'Actionsheet',
  extends: AmataModal,
  props: {
    title: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    },
    buttonLabels: {
      type: Array,
      default: () => ['OK']
    },
    buttonClasses: {
      type: Array,
      default: () => []
    },
    cancelButtonLabel: {
      type: String,
      default: 'キャンセル'
    },
    position: {
      type: String,
      default: 'bottom',
      validator: (value: string) => {
        return ['bottom', 'center', 'top'].includes(value)
      }
    },
    onConfirm: {
      type: Function,
      default: null
    }
  },
  computed: {
    klass(): any {
      return {
        Actionsheet__bottom: this.position === 'bottom',
        Actionsheet__center: this.position === 'center',
        Actionsheet__top: this.position === 'top'
      }
    }
  },
  beforeMount(this: any) {
    document.body.appendChild(this.$el)
  },
  methods: {
    /**
     * confirm ボタンをクリックした時のハンドラー
     */
    async confirm(this: any, buttonIndex: number) {
      if (this.onConfirm) {
        this.onConfirm(buttonIndex)
      }
      removeElement(this.$el)
      return buttonIndex
    },

    // /**
    //  * cancel ボタンをクリックした時のハンドラー
    //  */
    // onCancel() {
    //   this.$emit('onCancel')
    //   this.$destroy()
    //   removeElement(this.$el)
    // },

    /**
     * ボタンのクラスを取得する
     */
    getButtonClass(this: any, index: number): string {
      if (this.buttonClasses && this.buttonClasses.length >= index + 1) {
        return this.buttonClasses[index]
      } else {
        return ''
      }
    },

    close() {
      setTimeout(() => {
        this.$destroy()
        removeElement(this.$el)
      }, 150)
    }
  }
})
